import React from 'react';

const THead = ({ days, onSortChange }) => {
    const head2ndRow = [];
    const dayTh = days.map(day => {
        head2ndRow.push(<th key={`${day}_spends`}>Spends</th>);
        head2ndRow.push(<th key={`${day}_conversions`}>Conversions</th>);
        head2ndRow.push(<th key={`${day}_ecost`}>ECost</th>);

        return <th colSpan={3} key={day}>{day}</th>;
    });

    return (
        <thead>
            <tr>
                <th rowSpan={2} onClick={() => onSortChange('affid')}>Affid</th>
                <th rowSpan={2} onClick={() => onSortChange('country')}>Country</th>
                <th rowSpan={2} onClick={() => onSortChange('device')}>Device</th>
                {dayTh}
            </tr>
            <tr>
                {head2ndRow}
            </tr>
        </thead>
    );
};

export default THead;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/DaysCountryTable/components/THead/index.js